"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Tooltip = void 0;
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _chainFunction = _interopRequireDefault(require("chain-function"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _react = _interopRequireWildcard(require("react"));
var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes"));
var _Popper = require("../utils/_Popper");
var _useUniqueId = require("../utils/useUniqueId");
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _Tooltip = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Tooltip.css") : void 0);
var _excluded = ["children", "delay", "flipContainer", "id", "innerContainerProps", "message", "placement", "showOnLoad", "targetProps", "outerPopperProps", "doNotDescribe"];
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty2(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var CSS_BLOCK = 'sapcnqr-tooltip';

/**
 * The **Tooltip** component is a lightweight overlay that contains a short message
 * which provides the user context about an unknown or unfamiliar element in an interface.
 */

var Tooltip = exports.Tooltip = /*#__PURE__*/_react.default.forwardRef(function (_props, ref) {
  var _context;
  var addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  var props = addChildProps ? _objectSpread(_objectSpread({}, _props), addChildProps(Tooltip, _props)) : _props;
  var children = props.children,
    _props$delay = props.delay,
    delay = _props$delay === void 0 ? 0 : _props$delay,
    flipContainer = props.flipContainer,
    id = props.id,
    innerContainerProps = props.innerContainerProps,
    message = props.message,
    _props$placement = props.placement,
    placement = _props$placement === void 0 ? ['right', 'top', 'left', 'bottom'] : _props$placement,
    showOnLoad = props.showOnLoad,
    targetProps = props.targetProps,
    outerPopperProps = props.outerPopperProps,
    doNotDescribe = props.doNotDescribe,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classnames = _bind.default.bind(_Tooltip.default);
  var _useState = (0, _react.useState)(showOnLoad),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    showTooltip = _useState2[0],
    setShowTooltip = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    queueTooltip = _useState4[0],
    setQueueTooltip = _useState4[1];
  var tooltipId = (0, _useUniqueId.useUniqueId)();
  if (id) {
    tooltipId = id;
  }
  var targetComponent = _react.default.Children.only(children);
  var _targetComponent$prop = targetComponent.props,
    disabled = _targetComponent$prop.disabled,
    onBlur = _targetComponent$prop.onBlur,
    onFocus = _targetComponent$prop.onFocus,
    onKeyDown = _targetComponent$prop.onKeyDown,
    onMouseEnter = _targetComponent$prop.onMouseEnter,
    onMouseLeave = _targetComponent$prop.onMouseLeave;
  var handleFocus = function handleFocus() {
    setQueueTooltip(true);
  };
  var handleBlur = function handleBlur() {
    setShowTooltip(false);
    setQueueTooltip(false);
  };
  var handleMouseLeave = function handleMouseLeave() {
    setShowTooltip(false);
    setQueueTooltip(false);
  };
  var handleMouseEnter = function handleMouseEnter() {
    setQueueTooltip(true);
  };
  var tooltipTimer;
  var startTimer = function startTimer() {
    if (typeof setTimeout === 'function') {
      tooltipTimer = setTimeout(function () {
        return setShowTooltip(true);
      }, delay);
    }
  };
  var clearTimer = function clearTimer() {
    if (typeof clearTimeout === 'function') {
      clearTimeout(tooltipTimer);
    }
  };
  (0, _react.useEffect)(function () {
    if (queueTooltip) {
      startTimer();
    } else {
      clearTimer();
    }
    return clearTimer;
  }, [queueTooltip]);
  (0, _react.useEffect)(function () {
    if (disabled) {
      setShowTooltip(false);
      setQueueTooltip(false);
    }
  }, [disabled]);
  var handleKeyDown = function handleKeyDown(event) {
    /*
        If the Escape key is pressed when the Tooltip's target has focus
        and the tooltip is visible
        then hide the Tooltip
    */
    if (showTooltip && event.key === 'Escape') {
      event.preventDefault();
      setShowTooltip(false);
    }
  };
  var targetAriaAttributes = {
    'data-tooltip-target': true
  };
  var ariaDescribedby = showTooltip && !doNotDescribe ? (0, _filter.default)(_context = (0, _toConsumableArray2.default)(new _set.default([tooltipId, targetComponent.props['aria-describedby']]))).call(_context, Boolean).join(' ') : targetComponent.props['aria-describedby'];
  if (ariaDescribedby) {
    targetAriaAttributes['aria-describedby'] = ariaDescribedby;
  }
  var renderTargetComponent = function renderTargetComponent(referenceRef, referenceProps, targetClasses, additionalProps) {
    return /*#__PURE__*/_react.default.cloneElement(targetComponent, _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, additionalProps), referenceProps), targetAriaAttributes), {}, {
      ref: (0, _reactMergeRefs.default)([targetComponent.ref, referenceRef]),
      onBlur: (0, _chainFunction.default)(handleBlur, onBlur),
      onFocus: (0, _chainFunction.default)(handleFocus, onFocus),
      onKeyDown: (0, _chainFunction.default)(handleKeyDown, onKeyDown),
      onMouseEnter: (0, _chainFunction.default)(handleMouseEnter, onMouseEnter),
      onMouseLeave: (0, _chainFunction.default)(handleMouseLeave, onMouseLeave)
    }));
  };
  var classes = classnames(CSS_BLOCK, (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "--in"), showTooltip));
  return /*#__PURE__*/_react.default.createElement(_Popper.Popper, (0, _extends2.default)({
    showArrow: true
  }, outerPopperProps, {
    arrowClassName: classnames("".concat(CSS_BLOCK, "__arrow")),
    flipContainer: flipContainer,
    popperClassName: classes,
    popperPlacement: placement,
    popperProps: _objectSpread(_objectSpread({}, otherProps), {}, {
      id: "".concat(tooltipId, "-popper"),
      'aria-live': 'assertive',
      role: 'tooltip',
      innerRef: ref
    }),
    show: !disabled && showTooltip,
    renderTargetComponent: renderTargetComponent,
    targetProps: targetProps
  }), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, innerContainerProps, {
    className: classnames("".concat(CSS_BLOCK, "__inner"), innerContainerProps === null || innerContainerProps === void 0 ? void 0 : innerContainerProps.className),
    id: tooltipId
  }), message));
});
Tooltip.displayName = 'Tooltip';
Tooltip.propTypes = {
  /** React component to which the **Tooltip** will be attached. */
  children: _propTypes.default.node.isRequired,
  /** Text to display in the *Tooltip**. */
  message: _propTypes.default.node.isRequired,
  /** Delay (in milliseconds) before tooltip appears */
  delay: _propTypes.default.number,
  /** Additional props to spread to tooltip target. */
  targetProps: _propTypes.default.object,
  /** Used to create a boundary for the underlying Popper to stay within. */
  flipContainer: _CustomPropTypes.default.elementOrArrayOfElements(),
  /** Custom id for the tooltip. */
  id: _propTypes.default.string,
  /** Additional props to spread to the inner tooltip message container. */
  innerContainerProps: _propTypes.default.object,
  /** Placement of the **Popover** relative to the children element.
   * Options are 'auto', 'auto-start', 'auto-end', 'top', 'top-start', 'top-end',
   * 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end', 'right',
   * 'right-start', 'right-end'. If you use an array of strings, the first item in the
   * array is the default placement and the following ones are chosen in order as
   * fallback placements if the preceding ones don’t work. */
  placement: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOf(_Popper.POPPER_PLACEMENTS)), _propTypes.default.oneOf(_Popper.POPPER_PLACEMENTS)]),
  // eslint-disable-next-line max-len
  /** @ignore set by IconButton to suppress multiple ariaLabel announcement whenariaLabel is same as Tooltip msg. */
  doNotDescribe: _propTypes.default.bool,
  /** @ignore Controls whether the **Tooltip** is visible. */
  showOnLoad: _propTypes.default.bool,
  /** @ignore used in Shellbar to override arrow on Tooltip */
  outerPopperProps: _propTypes.default.object
};
var _default = exports.default = Tooltip;